import type { LeadStatus } from "@/shared/api/generated/types/marketing"

export const LEAD_STATUS_KEYS: Record<LeadStatus, string> = {
	new: "leads.status.new",
	in_progress: "leads.status.inProgress",
	processed: "leads.status.processed",
}

export const LEAD_STATUS_CLASSES: Record<LeadStatus, string> = {
	new: "bg-amber-100 text-amber-800",
	in_progress: "bg-blue-100 text-blue-800",
	processed: "bg-emerald-100 text-emerald-800",
}

export const LEAD_UTM_FIELDS = [
	"source",
	"medium",
	"campaign",
	"content",
	"term",
] as const

export const LEADS_PAGE_SIZES = [25, 50, 100] as const
export type LeadsPageSize = (typeof LEADS_PAGE_SIZES)[number]
export const LEADS_DEFAULT_PAGE_SIZE: LeadsPageSize = 25

export const isLeadStatus = (value: unknown): value is LeadStatus =>
	typeof value === "string" && Object.hasOwn(LEAD_STATUS_KEYS, value)

export const isLeadsPageSize = (value: unknown): value is LeadsPageSize =>
	typeof value === "number" &&
	LEADS_PAGE_SIZES.some((pageSize) => pageSize === value)
